/** Lokales Datum als YYYY-MM-DD (nicht UTC – sonst kippt der Tag um Mitternacht). */
export function isoDate(d = new Date()) {
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function addDays(iso, n) {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + n);
  return isoDate(d);
}

/** 1.5 → "1:30 h" */
export function hours(h) {
  const mins = Math.round(Number(h || 0) * 60);
  return `${Math.floor(mins / 60)}:${String(mins % 60).padStart(2, '0')} h`;
}

/** Sekunden → "01:23:45" */
export function clock(sec) {
  const s = Math.max(0, Math.floor(sec));
  return [Math.floor(s / 3600), Math.floor(s / 60) % 60, s % 60].map((n) => String(n).padStart(2, '0')).join(':');
}

/** Laufzeit auf Viertelstunden runden, mindestens 0.25 h. */
export function roundQuarter(ms) {
  const h = ms / 3_600_000;
  return Math.max(0.25, Math.round(h * 4) / 4);
}

const WD = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
/** "Heute", "Gestern", "Morgen" oder "Do 29.10." */
export function dayLabel(iso) {
  if (!iso) return '';
  const today = isoDate();
  if (iso.startsWith(today)) return 'Heute';
  if (iso.startsWith(addDays(today, -1))) return 'Gestern';
  if (iso.startsWith(addDays(today, 1))) return 'Morgen';
  const d = new Date(`${iso.slice(0, 10)}T12:00:00`);
  return `${WD[d.getDay()]} ${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.`;
}

export function dateTimeLabel(isoTs) {
  if (!isoTs) return '';
  const d = new Date(isoTs);
  const t = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  return `${dayLabel(isoDate(d))} ${t}`;
}

export function initials(name = '') {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join('') || '?';
}

export function num(n) {
  return Number(n).toLocaleString('de-CH', { maximumFractionDigits: 2 });
}

export function adresse(kunde) {
  if (!kunde) return '';
  return [kunde.strasse, [kunde.plz, kunde.ort].filter(Boolean).join(' ')].filter(Boolean).join(', ');
}

/** ISO-Kalenderwoche */
export function kw(iso) {
  const d = new Date(`${iso}T12:00:00`);
  const day = (d.getDay() + 6) % 7;
  d.setDate(d.getDate() - day + 3);
  const first = new Date(d.getFullYear(), 0, 4);
  return 1 + Math.round(((d - first) / 86_400_000 - 3 + ((first.getDay() + 6) % 7)) / 7);
}
